import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
	QueryParamsState,
	ReviewsSortBy,
	ReviewsSortByUnion,
} from '../models/university-reviews.models';

@Injectable({ providedIn: 'root' })
export class QueryParamsStatesService {
	sortOptions = [
		{
			id: ReviewsSortBy.MostHelpful,
			text: 'Most helpful',
		},
		{
			id: ReviewsSortBy.LatestReview,
			text: 'Latest review',
		},
		{
			id: ReviewsSortBy.EarliestReview,
			text: 'Earliest review',
		},
		{
			id: ReviewsSortBy.HighestRanked,
			text: 'Highest ranked',
		},
		{
			id: ReviewsSortBy.LowestRanked,
			text: 'Lowest ranked',
		},
	];

	private readonly _initialQueryParams = {
		university: '',
		page: 1,
		limit: 10,
		offset: 1,
		contains: '',
		sortBy: this.sortOptions[3].id as ReviewsSortByUnion,
	};

	private _queryParams = this._initialQueryParams;

	private _queryParamsState = new BehaviorSubject<QueryParamsState>(
		this._initialQueryParams,
	);

	queryParamsState$ = this._queryParamsState.asObservable();

	getInitialQueryParamsState() {
		return this._initialQueryParams;
	}

	updateQueryParamsState(args: Partial<QueryParamsState>) {
		const newState = { ...this._queryParams, ...args };
		this._queryParams = newState;
		this._queryParamsState.next(newState);
	}

	resetQueryParamsState() {
		this._queryParamsState.next(this._initialQueryParams);
	}
}
